import { render, staticRenderFns } from "./MessageFile.vue?vue&type=template&id=442d693d&"
import script from "./MessageFile.vue?vue&type=script&lang=js&"
export * from "./MessageFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports